import PoziAPIData from 'api/data'
import PoziNotifications from 'utils/notifications'

/**
 * Retrieval of data typically from 3rd party data sources via AJAX.
 */
export default function PoziDataRetrieval () {
  // ============================================================
  // Public Variables
  // ============================================================

  /**
   * This object
   * @type {object}
   */
  const _ = this

  // ============================================================
  // Private Variables
  // ============================================================

  // var cardProcessing

  // ============================================================
  // Public Functions
  // ============================================================

  /**
   * Init
   */
  _.init = function () {}

  /**
   * Wrapper for jQuery AJAX ajax command.
   * https://api.jquery.com/jQuery.ajax/
   */
  _.ajax = function (url, cb) {}

  /**
   * Wrapper for jQuery AJAX get command.
   * https://api.jquery.com/jquery.get/
   */
  _.get = function (url, cb) {}

  /**
   * Wrapper for jQuery AJAX get command.
   * https://api.jquery.com/jquery.get/
   * @param url URL
   * @param cb callback
   * @param fail failure callback
   */
  _.getJSON = function (url, cbSuccess, cbFail) {
    PoziAPIData().ajax({
      url,
      error: cbFail || ajaxFail,
      success: cbSuccess
    })
  }

  /**
   * Wrapper for jQuery AJAX get command with method set.
   * https://api.jquery.com/jquery.get/
   * @param url URL
   * @param cb callback
   * @param fail failure callback
   */
  _.getAjax = function (url, cbSuccess, cbFail) {
    PoziAPIData().ajax({
      url,
      error: cbFail || ajaxFail,
      success: cbSuccess
    })
  }

  /**
   * Wrapper for jQuery AJAX post command.
   * https://api.jquery.com/jQuery.post/
   */
  _.post = function (url, data, cb) {}

  var ajaxFail = function (jqxhr, textStatus, error) {
    const err = textStatus + ' ' + error
    console.error('Ajax request failed ' + err)
    PoziNotifications().warning('Failed to get data. Please try again shortly.')
  }
}
